import { apiV1 } from '~/services/api';

function getVersioning() {
  return apiV1.request({
    url: '/v1/ui/account/version',
  });
}

function upgradeVersioning() {
  return apiV1.request({
    method: 'POST',
    data: {
      update: true,
    },
    url: 'v1/ui/account/version',
  });
}

export { getVersioning, upgradeVersioning };
